import PropTypes from 'prop-types'
import React from 'react'

export default function IconCart({ styles }) {
  return (
    <svg
      style={styles}
      width="11"
      height="11"
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6938 3.30696C10.7158 3.24163 10.7239 3.16989 10.7159 3.09995C10.7089 3.03035 10.6858 2.96333 10.6498 2.90553C10.6138 2.84774 10.5668 2.80017 10.5108 2.76723C10.4558 2.73484 10.3938 2.71753 10.3318 2.71753H3.42285L2.81685 1.0827C2.74985 0.900088 2.63684 0.745811 2.49084 0.635728C2.34484 0.526545 2.17485 0.46875 1.99985 0.46875H0.943848V1.34031H2.07385L2.10185 1.41834L4.47385 7.81925C4.50285 7.89852 4.55285 7.96598 4.61685 8.01399C4.68085 8.06167 4.75485 8.08697 4.83185 8.08697H8.83185C8.99185 8.08697 9.13785 7.97352 9.19485 7.80452L10.6938 3.30696ZM8.56285 7.21587H5.08984L3.74585 3.58908H9.77185L9.71585 3.75989L8.56285 7.21587Z"
        fill="#898989"
      />
      <path
        d="M5.06885 10.5851C5.48285 10.5851 5.81885 10.2075 5.81885 9.74177C5.81885 9.27603 5.48285 8.89844 5.06885 8.89844C4.65485 8.89844 4.31885 9.27603 4.31885 9.74177C4.31885 10.2075 4.65485 10.5851 5.06885 10.5851Z"
        fill="#898989"
      />
      <path
        d="M8.56885 10.5851C8.98285 10.5851 9.31885 10.2075 9.31885 9.74177C9.31885 9.27603 8.98285 8.89844 8.56885 8.89844C8.15485 8.89844 7.81885 9.27603 7.81885 9.74177C7.81885 10.2075 8.15485 10.5851 8.56885 10.5851Z"
        fill="#898989"
      />
    </svg>
  )
}

IconCart.propTypes = {
  styles: PropTypes.any,
}
